import { useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";

import { useAxios, useComponent } from "../../hooks";
import {
  customFieldsDetailsObject,
  objectFromResponse,
} from "./custom field details component/customFieldsDetailsObject";
import Form from "./custom field details component/Form";
import { Loader } from "../../components";

export default function CustomFieldDetails() {
  const axios = useAxios();

  const { fieldID } = useParams();
  const { loader } = useComponent();

  const [groups, setGroups] = useState([]);
  const [editState, setEditState] = useState(true);
  const [PlatformTenantList, setPlatformTenantList] = useState([]);
  const [controlTypes, setControlTypes] = useState([
    {
      field_type_id: 1,
      field_type_name: "Range",
    },

    {
      field_type_id: 3,
      field_type_name: "Text",
    },

    {
      field_type_id: 4,
      field_type_name: "Date",
    },

    {
      field_type_id: 2,
      field_type_name: "DropDown",
    },

    {
      field_type_id: 5,
      field_type_name: "File",
    },
  ]);
  const [formData, setFormData] = useState(customFieldsDetailsObject);

  useEffect(() => {
    axios({
      url: "/fields/fieldsGroups",
    }).then((response) => {
      if (response.status) {
        let category = [];
        response.data.map((cat) =>
          Object.entries(cat).map(([key, value]) =>
            category.push({ id: parseInt(key), label: value })
          )
        );
        setGroups(category);
        loader.apiComplete();
      }
    });

    axios({
      url: "/list/dynamicDashboard",
      disableRedirect: true,
    }).then((res) => {
      if (res.status) {
        setPlatformTenantList(res.data);
      }
    });

    if (!!fieldID) {
      setEditState(false);
      axios({
        url: "/custom-field/" + fieldID,
        method: "GET",
      }).then((response) => {
        if (response.status) {
          loader.apiComplete(1);
          setFormData(objectFromResponse(response.data));
        }
      });
    } else {
      loader.apiComplete(1);
    }
  }, [axios, loader, fieldID]);

  return (
    <Loader>
      <Form
        PlatformTenantList={PlatformTenantList}
        groups={groups}
        formData={formData}
        controlTypes={controlTypes}
        setControlTypes={setControlTypes}
        setFormData={setFormData}
        editState={editState}
        setEditState={setEditState}
      />
    </Loader>
  );
}
